import { render } from "./TestPage.vue?vue&type=template&id=3feed4d0&scoped=true"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"

import "./TestPage.vue?vue&type=style&index=0&id=3feed4d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\murat\\OneDrive\\mkss\\source\\vuejs\\practiceone\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feed4d0"]])

export default __exports__